import React from "react"
import { Router } from "@reach/router"
import Homepage from "./homepage"
import Stores from "./stores"
import Auth from "./auth"
import CheckoutSuccess from "./success"
import CheckoutPending from "./pending"
import CheckoutFail from "./fail"
import { inBrowser } from "@omnichannel/ace-b2b-elements"
import SEO from "../components/seo"

const IndexPage = (props) => {
  const homeMobileImgLink = `https://d3en5mej4c6rt8.cloudfront.net/banner/5f229cf29cea9402d562ce2c_mobilexb39v4n7qw.jpg`

  console.log("index page::", new Date())

  return (
    <>
      <SEO
        imageUrl={homeMobileImgLink}
        keywords="hardware, home improvements, garden, lawn, tools, automotive" />
      {inBrowser && (
        <Router>
          <Homepage path="/" />
          <Auth path="/auth" {...props} />
          <Stores path="/stores" />
          <CheckoutSuccess path="/success" />
          <CheckoutPending path="/pending" />
          <CheckoutFail path="/fail" />
        </Router>
      )}
    </>
  )
}

export default IndexPage
